import React, { Fragment, useEffect, useState } from "react";
import { cdnImg } from "../../../Utils/cdnImage";
import BetSlipContext from "../../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../../context/AuthContext";
import { inRange, isEmpty, startCase } from "lodash";
import { formatWithCommas } from "../../../Utils/Toast";

const HomeRight = () => {
  const [tab, setTab] = useState(true);
  const numberArray = [10, 100, 200, 500, 10000, 20000];

  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const betLoader = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betLoader;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const limit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.limit;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });

  const setResetBetPosition = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setResetBetPosition;
  });
  const handelPlaceBetFair = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBetFair;
  });
  const handelPlaceFancy = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceFancy;
  });
  const handelPlaceBookmaker = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBookmaker;
  });
  const toastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.toastObject;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const setLoginModal = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLoginModal;
  });
  const handelPlaceSportBook = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceSportBook;
  });

  const handelPlaceToss = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceToss;
  });
  const [bidPriceDisabled, setBidPricDisabled] = useState(true);
  const [timeLeft, setTimeLeft] = useState(limit?.betDelay || 5);
  useEffect(() => {
    if (
      inRange(
        Number(betSlipObject?.bidPrice),
        limit?.minAmount || 1,
        limit?.maxAmount + 1 || 100
      )
    ) {
      setBidPricDisabled(false);
    } else {
      setBidPricDisabled(true);
    }
  }, [betSlipObject, limit]);
  const placeBet = () => {
    if (!isEmpty(user)) {
      if (
        betSlipObject?.playType == "betFaire" ||
        betSlipObject?.playType == "multi" ||
        betSlipObject?.playType == "home"
      ) {
        handelPlaceBetFair();
      } else if (betSlipObject?.playType == "fancy") {
        handelPlaceFancy();
      } else if (betSlipObject?.playType == "bookmaker") {
        handelPlaceBookmaker();
      } else if (betSlipObject?.playType == "sportBook") {
        handelPlaceSportBook();
      } else if (betSlipObject?.playType == "toss") {
        handelPlaceToss();
      }
    } else {
      setShowBetDialog(false);
      setLoginModal(true);
    }
  };

  useEffect(() => {
    if (betLoader) {
      if (timeLeft <= 0) return;

      const interval = setInterval(() => {
        setTimeLeft((t) => t - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [timeLeft, betLoader]);

  useEffect(() => {
    if (toastObject?.status) {
      const timer = setTimeout(() => {
        setToastObject({});
      }, 4000);

      return () => clearTimeout(timer); // Cleanup on unmount
    }
  }, [toastObject]);
  return (
    <div className="col-right">
      <div className={`slip-wrap no-open-bet_slip ${!tab ? "close" : ""}`}>
        <h3 onClick={() => setTab(!tab)}>
          <a className="to-expand" style={{ cursor: "pointer" }}>
            Bet Slip
          </a>
        </h3>
        {isEmpty(betSlipObject) &&isEmpty(toastObject?.message) &&
        <p id="noBetSlipInfo" style={{ display: "block" }}>
          Click on the odds to add selections to the betslip.
        </p>}
        {!isEmpty(toastObject?.message) &&
          toastObject?.status &&
          toastObject?.gameType == "betfair" && (
            <div className="message-bet">
              <h4 id="errorMsg" className={toastObject?.type}>
                {toastObject?.message}
              </h4>
            </div>
          )}
        {betLoader ? (
          <ul id="loadingMsg" className="loading">
            <li>
              <img src={cdnImg("/assets/images/loading40.gif")} />
            </li>
            <li id="countDownTime">
              {" "}
              Placing your bets, Please wait {timeLeft} sec remaining…
            </li>
          </ul>
        ) : (
          !isEmpty(betSlipObject) &&
          betSlipObject?.playType == "betFaire" && (
            <>
              <div
                id="betSlipBoard"
                className="bet_slip"
                style={{ display: "block" }}
              >
                <div
                  id="betList"
                  className="slip-list"
                  style={{ "max-height": "calc(100% - 86px)" }}
                >
                  <ul
                    id="backSlipHeader"
                    className="slip-head"
                    name="slipHeader"
                    style={{ display: "block" }}
                  >
                    <li className="col-bet">
                      {startCase(betSlipObject?.betType)} (Bet For)
                    </li>
                    <li id="oddsHeader" className="col-odd">
                      Odds
                    </li>
                    <li className="col-stake">Stake</li>
                    <li className="col-profit">Profit</li>
                  </ul>
                  <div
                    id="header_Back_34941733"
                    style={{ display: "block" }}
                    count={1}
                  >
                    <h4>
                      <img
                        className="icon-in_play"
                        src={cdnImg("/images/transparent.gif")}
                      />{" "}
                      {betSlipObject?.object?.eventName}
                    </h4>
                    <dl
                      className={`slip-${
                        betSlipObject?.playType == "sportBook"
                          ? "book"
                          : ["lay", "No"].includes(betSlipObject?.betType)
                          ? "lay"
                          : "back"
                      }`}
                      style={{ display: "block" }}
                    >
                      <dt>
                        <a
                          onClick={() => {
                            setShowBetDialog(false);
                            setResetBetPosition(true);
                          }}
                          id="delete"
                          className="delete"
                          style={{ cursor: "pointer" }}
                        >
                          delete
                        </a>
                        <span className="short-amount">
                          {betSlipObject?.teamName}
                        </span>
                        <span id="marketName">Match Odds</span>
                      </dt>
                      <dd className="col-odd">
                        <input
                          id="odds"
                          type="text"
                          disabled
                          value={betSlipObject?.odds}
                          autoComplete="off"
                        />
                      </dd>
                      <dd className="col-stake">
                        <input
                          id="inputStake"
                          type="text"
                          maxLength={7}
                          value={betSlipObject?.bidPrice}
                        />
                      </dd>
                      <dd id="profitLiability" className="col-profit">
                        0.00
                      </dd>
                      <dd
                        id="stakePopupList"
                        className="col-stake_list"
                        stakepopuplisttype="extended"
                        style={{ display: "block" }}
                        bet="bet_34941733_1_250382399_414464_0_00_1"
                      >
                        <ul>
                          {(profileData?.stake?.length > 0
                            ? profileData?.stake?.sort(function (a, b) {
                                return a - b;
                              })
                            : numberArray
                          )
                            ?.slice(0, 6)
                            ?.map((res) => {
                              return (
                                <li
                                  onClick={() => {
                                    setBetSlipObject({
                                      ...betSlipObject,
                                      bidPrice: Number(res),
                                    });
                                  }}
                                >
                                  <a
                                    className="btn"
                                    id="selectStake_1"
                                    style={{ cursor: "pointer" }}
                                  >
                                    {res}
                                  </a>
                                </li>
                              );
                            })}
                        </ul>
                      </dd>
                      <dd className="keep-option">
                        <p className="dynamic-min-bet">
                          Min Bet:{" "}
                          <strong id="dynamicMinBet">
                            {formatWithCommas(limit?.minAmount)}
                          </strong>
                        </p>
                      </dd>
                      <dd
                        id="inningsRuns"
                        className="inn_runs"
                        style={{ display: "none" }}
                      >
                        <dl>
                          <dt id="ifRuns" />
                          <dd>
                            <span id="runsPL" className="green" />
                          </dd>
                          <dt id="ifLess" />
                          <dd>
                            <span id="lessPL" className="green" />
                          </dd>
                        </dl>
                      </dd>
                    </dl>
                  </div>
                </div>
                <div id="betSlipFullBtn" className="full_btn">
                  <dl className="sum">
                    <dt>Liability</dt>
                    <dd>
                      <span id="total" className="red">
                        {betSlipObject?.bidPrice}
                      </span>
                    </dd>
                  </dl>
                  <ul className="btn-wrap">
                    <li>
                      <a
                        onClick={() => {
                          setShowBetDialog(false);
                          setResetBetPosition(true);
                        }}
                        id="cancelAll"
                        className="btn"
                        style={{ cursor: "pointer" }}
                      >
                        Cancel
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => {
                          placeBet();
                        }}
                        id="placeBets"
                        className={`btn-send ${
                          bidPriceDisabled ? "disable" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        tabIndex={0}
                      >
                        Place Bets
                      </a>
                    </li>
                  </ul>
                  <ul className="slip-option">
                    <li>
                      <input id="comfirmBets" type="checkbox" />
                      <label htmlFor="comfirmBets">
                        Please confirm your bets.
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </>
          )
        )}
      </div>
    
    </div>
  );
};

export default HomeRight;
